module.exports = __webpack_public_path__ + "img/choose-packs.72200eea.webp";